<template>
  <div class="chart-section">
    <div class="chart-header">
      <div class="chart-header-icon">
        <feather-icon
          icon="BarChart2Icon"
          size="22"
        />
      </div>
      <div class="chart-header-text">
        <h3 class="chart-title">
          Engineer Allocation
        </h3>
        <p class="chart-subtitle">
          Request distribution by source & engineer
        </p>
      </div>
    </div>
    <div class="chart-body">
      <ChartTable
        :data-chart="dataChart"
        :chart-loading="chartLoading"
        @show-popup="handlePopupData"
      />
    </div>
    <PopupComponent
      v-if="showPopup"
      :name="popupData.name"
      :source="popupData.source"
      :user-data="userData"
      :user-loading="userLoading"
      @close="showPopup = false"
    />
  </div>
</template>

<script>
import ChartTable from './ChartTableEngineer.vue'
import PopupComponent from './PopupComponent.vue'

export default {
  components: {
    ChartTable,
    PopupComponent,
  },
  props: {
    dataChart: {
      type: Object,
      required: true,
    },
    userData: {
      type: Array,
      required: true,
    },
    userLoading: {
      type: Boolean,
      default: () => false,
    },
    chartLoading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showPopup: false,
      popupData: {},
    }
  },
  methods: {
    handlePopupData(data) {
      if (data && data.userID) {
        this.$emit('need-user-data', data.userID)
      }
      this.popupData = data
      this.showPopup = true
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-section {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebe9f1;
  box-shadow: 0 2px 8px rgba(34, 41, 47, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  @media (max-width: 991px) {
    min-height: 500px;
  }
}

.chart-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f8f7ff 0%, #fff 100%);
  border-bottom: 1px solid #ebe9f1;
}

.chart-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-header-text {
  flex: 1;
}

.chart-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #5e5873;
  margin: 0 0 0.25rem 0;
}

.chart-subtitle {
  font-size: 0.85rem;
  color: #b9b9c3;
  margin: 0;
}

.chart-body {
  flex: 1;
  padding: 1.5rem;
  overflow: auto;
}
</style>
